import { HttpContextToken } from '@angular/common/http';

/**
 * Token para omitir la inyección de seguridad en el interceptor.
 * Se usa para llamadas que no requieren Session-ID ni Auth Token (ej. Login inicial).
 * * Por defecto es 'false', lo que significa que todas las peticiones
 * son privadas a menos que se indique lo contrario.
 */
export const IS_PUBLIC_API = new HttpContextToken<boolean>(() => false);

/**
 * Token opcional para casos donde solo necesites el Session-ID pero NO el Auth Token.
 * Útil para flujos de registro o pre-validación donde aún no hay un JWT.
 */
export const ONLY_SESSION_ID = new HttpContextToken<boolean>(() => false);
